import React from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline'],
    [{ color: [] }, { background: [] }],
  ],
}

export default function Editor(props) {
  const [text, setText] = React.useState(props.descvalue)

  const onChange = text => {
    setText(text)
    props.setdescvalue(text)
  }
  // useEffect(() => {
  //   if(props.descvalue){
  //     setText(props.descvalue)
  //   }

  // }, [props.descvalue])

  return (
    <ReactQuill
      theme='snow'
      placeholder='Type'
      value={text}
      onChange={onChange}
      modules={modules}
    />
  )
}
